import * as type from '../actions/types';

const initialState = {
  data: {
    addOns: [], // No idea why this is in the API
    selectableRooms: [],
  },
  error: '',
  pending: true,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.HOLD_ACCOMMODATION_PENDING: {
      return {
        ...state,
        data: {},
        error: '',
        pending: true,
        success: false,
      };
    }

    case type.HOLD_ACCOMMODATION_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        pending: false,
        success: true,
      };
    }

    case type.HOLD_ACCOMMODATION_FAILURE: {
      return {
        ...state,
        pending: false,
        error: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};
